import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../assets/Logo.png'; // Reuse your existing logo

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-inner">
        <div className="footer-col footer-col-logo">
          <Link to="/" className="footer-logo">
            {Logo && (
              <img src={Logo} alt="Chawal Taka Logo" />
            )}
          </Link>
          <p className="footer-about">
            Chawal Taka is a contemporary Indian clothing brand made for modern Indian women. The brand creates thoughtfully designed, easy-to-wear Western and Indo-Western garments.
          </p>
        </div>

        <div className="footer-col">
          <h3 className="footer-col-title">Info.</h3>
          <ul className="footer-links">
            {/* Added Our Story Link */}
            <li><Link to="/our-story">Our Story</Link></li>
            <li><Link to="/about-us">About Us</Link></li>
            <li><Link to="/contact-us">Contact Us</Link></li>
          </ul>
        </div>

        <div className="footer-col">
          <h3 className="footer-col-title">Help</h3>
          <ul className="footer-links">
            <li><Link to="/shipping-policy">Shipping Policy</Link></li>
            <li><Link to="/returns-exchanges">Returns and Exchanges</Link></li>
            <li><Link to="/cancellation-refunds">Cancellation & Refunds</Link></li>
          </ul>
        </div>

        <div className="footer-col">
          <h3 className="footer-col-title">Follow Us</h3>
          <p>Stay in touch and see our new collections.</p>
          <div className="footer-socials">
            <a href="https://www.instagram.com/chawal.taaka/" aria-label="Instagram" target="_blank" rel="noopener noreferrer">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M3 16V8C3 5.23858 5.23858 3 8 3H16C18.7614 3 21 5.23858 21 8V16C21 18.7614 18.7614 21 16 21H8C5.23858 21 3 18.7614 3 16Z" stroke="currentColor" strokeWidth="2"/>
                <path d="M16.5 7.5V7.501" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </a>
            <a href="https://www.facebook.com/profile.php?id=61585136350812" aria-label="Facebook" target="_blank" rel="noopener noreferrer">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 2H15C13.6739 2 12.4021 2.52678 11.4645 3.46447C10.5268 4.40215 10 5.67392 10 7V10H7V14H10V22H14V14H17L18 10H14V7C14 6.73478 14.1054 6.48043 14.2929 6.29289C14.4804 6.10536 14.7348 6 15 6H18V2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </a>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} ChawalTaka. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;